// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <v-toolbar-title v-if="newRule">Add Rule</v-toolbar-title>
        <v-toolbar-title v-else>Edit Rule</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="canModify" color="blue" @click="save">Save</v-btn>
      </v-toolbar>
      <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Resource Type"
            v-model="rule.resourceType"
            required
            hide-details
            :disabled="!canModify"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Resource ID"
            v-model="rule.resourceID"
            required
            hide-details
            :disabled="!canModify"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            v-bind:items="permissionLevels"
            v-model="rule.permissions"
            item-value="level"
            label="Permissions"
            required
            hide-details
            :disabled="!canModify"
           ></v-select>
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            v-bind:items="roles"
            v-model="rule.roleID"
            item-value="id"
            item-text="name"
            label="Role"
            required
            hide-details
            :disabled="!canModify"
           ></v-select>
        </v-flex>
        <!-- <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Field Black List"
            v-model="rule.fieldsBlackList"
            hide-details
            :disabled="!canModify"
          ></v-text-field>
        </v-flex> -->
      </v-layout>
    </v-card-text>
    </v-card>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import {PERMISSIONS, WILDCARD, WILDCARDBSON} from 'vue-common/components/constants'
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
import {checkPermission} from 'vue-common/components/user'

import {AXIOSAPI} from '@/api/api'
import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      endpoint: ENDPOINT,
      rule: {
        resourceID: WILDCARD
      },
      errorText: '',
      newRule: false,
      permissionLevels: [
        {level: PERMISSIONS.READ, text: 'Read'},
        {level: PERMISSIONS.MODIFY, text: 'Modify'},
        {level: PERMISSIONS.CREATE, text: 'Create'},
        {level: PERMISSIONS.DELETE, text: 'Delete'}
      ],
      roles: []
    }
  },

  created () {
    if (this.$route.params.id === 'new') {
      this.newRule = true
    }

    this.getRoles()
    this.getRule()
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'rules', PERMISSIONS.MODIFY)
    }
  },

  methods: {
    getRule: function () {
      if (this.newRule) {
      } else {
        AXIOSAPI.get(ENDPOINT + 'accessRules/' + this.$route.params.id).then((response) => {
          this.rule = response.data
        })
      }
    },

    getRoles: function () {
      AXIOSAPI.get(ENDPOINT + 'roles').then((response) => {
        this.roles = response.data
        this.roles.unshift({
          name: 'Global',
          id: WILDCARDBSON
        })
      })
    },

    save: function () {
      if (this.rule.resourceType !== '' && this.rule.resourceType && this.rule.roleID && this.rule.permissions) {
        if (this.newRule) {
          AXIOSAPI.post(ENDPOINT + 'accessRules', this.rule).then(response => {
            this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = 'Failed to create: ' + e
          })
        } else {
          AXIOSAPI.put(ENDPOINT + 'accessRules/' + this.$route.params.id, this.rule).then(response => {
            this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = 'Failed to save: ' + e
          })
        }
      } else {
        this.errorText = 'Please completely fill out the form'
      }
    },

    exit: function () {
      this.$router.push({name: 'rules'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RuleEdit.vue